/**
 * --------------------------------------------------------------------------
 * NJ : AbstractComponent.js
 * --------------------------------------------------------------------------
 */

// import coreConfig from 'nj-component/core.config';

/**
  * ------------------------------------------------------------------------
  * Constants
  * ------------------------------------------------------------------------
  */

// Required const for all components :
// const NAME                = 'componentName'
// const DATA_KEY            = `${coreConfig.KEY_PREFIX}.componentName`
// const EVENT_KEY           = `.${DATA_KEY}`
// const DATA_API_KEY        = coreConfig.KEY_PREFIX


// const DEFAULT_OPTIONS = {
//
// };

// const SELECTOR = {
//
// };


/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class AbstractComponent {
  /**
   * Generic constructor for all components
   * @constructor
   * @param {Element} element
   * @param {Object} options
   */
  constructor(Component, element = null, options = {}) {
    if (this.constructor === AbstractComponent) {
      throw new TypeError('Abstract class "AbstractComponent" cannot be instantiated directly');
    }

    // Display error if el is valid HTML Element
    if (element && !(element instanceof Element)) {
      console.error(Error(`${element} is not an HTML Element`));
    }

    // If exists, destroy and reinitialize in child
    const ins = Component.getInstance(element);
    if (ins) {
      ins.dispose();
    }

    this.options = options;
    this.element = element;

    // It's necessary to implement line below to enable data api
    // if (this.element) {
    //   Data.setData(element, DATA_KEY, this);
    // }
  }

  /**
   * Initializes components
   * @param {class} Component
   * @param {Object} options
   * @param {String} selector - SELECTOR aka class identifier
   */
  static init(Component, options, selector) {
    const elements = document.querySelectorAll(selector);
    const instances = [];

    if (Boolean(elements) && elements instanceof NodeList) {
      for (let i = 0; i < elements.length; i++) {
        instances.push(new Component(elements[i], options));
      }
    }

    return instances;
  }

  /**
   * ------------------------------------------------------------------------
   * Implementation required
   * ------------------------------------------------------------------------
   */


  /**
   * Destroys an element's component
   */
  dispose() {
    throw new Error('You have to implement the method dispose !');
  }

  /**
   * This method which allows to get the current component instance associated to a DOM element
   * You can use it like this: `ComponentName.getInstance(component-name)
   * @param  {[type]} element [description]
   * @return {[type]}         [description]
   */

  // eslint-disable-next-line no-unused-vars
  static getInstance(element) {
    throw new Error('You have to implement the method getInstance !');
    // example :
    // return Data.getData(element, DATA_KEY)
  }

  // static selector = SELECTOR
}


/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */

// Configure event handling below
// Example :
// https://github.com/twbs/bootstrap/blob/v4-without-jquery/js/src/carousel.js
// EventHandler
//   .on(document, Event.CLICK_DATA_API, Selector.DISMISS, ComponentName.handleDismiss(new Component()));


export default AbstractComponent;
